(function() {
	"use strict";
	var FinModaleIniziativaController = function ($scope, $modalInstance, labelSrvc) {
		$scope.msg = labelSrvc.getLabel;

		$scope.iniziativaBanca = function () {
			$modalInstance.close('B');
		};
	  
		$scope.iniziativaCliente = function () {
			$modalInstance.close('C');
		};
		
		$scope.cancel = function () {
			$modalInstance.dismiss();
		};
	};
	FinModaleIniziativaController.$inject = ['$scope', '$modalInstance', 'FinLabelSrvc'];
	angular.module('cbl.finanza.mf').controller('FinModaleIniziativaCtrl', FinModaleIniziativaController);
}());


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finModali/iniziativa/finModaleIniziativaCtrl.js
 ** module id = 12
 ** module chunks = 0 1 2
 **/